
import Vue, { PropType } from 'vue';
import { isAfter } from 'date-fns';

// Services and types
import { CandidateStudyProgram } from '~/services/CSPService';
import { SchoolVerification } from '~/services/SchoolService';
import SchoolVerificationInfo from './SchoolVerificationInfo.vue';

// Components
import StudyProgramStatusIcon from '~/components/profile/components/StudyProgramStatusIcon.vue';
import SchoolNotFoundWarning from './SchoolNotFoundWarning.vue';

interface StudyProgramDetail {
    id: string;
    schoolId: number | null;
    schoolName: string;
    name: string | null;
    level: string | null;
    logo: string;
}

export default Vue.extend({
    name: 'StudyProgramDetails',
    components: {
        SchoolVerificationInfo,
        StudyProgramStatusIcon,
        SchoolNotFoundWarning,
    },
    props: {
        program: {
            type: Object as PropType<CandidateStudyProgram>,
            required: true,
        },
        verification: {
            type: Object as PropType<SchoolVerification>,
            default: null,
        },
        editVisible: Boolean,
        editEnabled: Boolean,
    },
    computed: {
        details(): StudyProgramDetail {
            const p = this.program;
            const level = p.studyProgram.level ? p.studyProgram.level.name : '';

            const schoolId = p.studyProgram.school ? p.studyProgram.school.id : null;
            const schoolName = p.studyProgram.school
                ? p.studyProgram.school.name
                : p.studyProgram.customSchoolName || '';
            const logo = p.studyProgram.school ? p.studyProgram.school.logo : '';

            return {
                id: p.id,
                schoolId,
                schoolName,
                name: p.studyProgram.name || null,
                level,
                logo,
                schoolSaved: !p.showWarning,
            };
        },
        timeSpan(): string {
            if (!this.program.start && !this.program.end) {
                return '';
            }

            if (this.program.start && !this.program.end) {
                return `${this.program.start?.getFullYear()}`;
            } else if (this.program.end && !this.program.start) {
                return `-> ${
                    this.isPresent
                        ? this.$t('general.present').toString().toLocaleLowerCase()
                        : this.program.end?.getFullYear()
                }`;
            }

            const end = this.isPresent
                ? this.$t('general.present').toString().toLocaleLowerCase()
                : this.program.end?.getFullYear();
            return `${this.program.start?.getFullYear()} - ${end}`;
        },
        isPresent(): boolean {
            return !!this.program.end && isAfter(this.program.end, new Date());
        },
    },
    methods: {
        editProgram(programId) {
            this.$emit('edit', programId);
        },
    },
});
